// Configuration for the frontend application

// The API base URL. 
// If VITE_API_BASE_URL is set (non-empty), use it.
// Otherwise:
//   - If running on localhost/127.0.0.1, default to http://localhost:8000 (dev mode)
//   - If running elsewhere (production), use relative path (empty string) to hit same origin
const envApiUrl = import.meta.env.VITE_API_BASE_URL;
let apiBase;

if (envApiUrl && envApiUrl.trim() !== '') {
    apiBase = envApiUrl;
} else {
    if (typeof window !== 'undefined') {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            apiBase = 'http://localhost:8000';
        } else if (window.location.port === '5173') {
            // Dev mode on network IP
            apiBase = `http://${window.location.hostname}:8000`;
        } else {
            apiBase = ''; // Relative path for production (same origin)
        }
    } else {
        apiBase = 'http://localhost:8000'; // Fallback for SSR/tests
    }
}

export const API_BASE_URL = apiBase;

// The WebSocket base URL.
// Checks VITE_WS_BASE_URL first, then falls back to hostname-based inference.
const envWsUrl = import.meta.env.VITE_WS_BASE_URL;
let wsUrl;

if (envWsUrl && envWsUrl.trim() !== '') {
    wsUrl = envWsUrl;
} else if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        wsUrl = 'ws://localhost:8000';
    } else if (window.location.port === '5173') {
        wsUrl = `ws://${window.location.hostname}:8000`;
    } else {
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        wsUrl = `${protocol}//${window.location.host}`;
    }
} else {
    wsUrl = 'ws://localhost:8000';
}

export const WS_BASE_URL = wsUrl;
